import { computed, defineComponent } from "vue";
import { useRoute } from "vue-router";
import { useLocale } from "../locales/i18n.js";

type DockItem = {
    id      : string;
    label   : string;
    icon    : string;
    to      : string;
    active  : (path: string) => boolean;
};

function isPath(path: string, prefix: string): boolean {
    return path === prefix || path.startsWith(`${prefix}/`);
}

const DockItems: DockItem[] = [
    {
        id      : "home",
        label   : "navbar.home.label",
        icon    : "monitoring",
        to      : "/",
        active  : path => path === "/" || isPath(path, "/dashboards"),
    },
    {
        id      : "logs",
        label   : "navbar.logs.label",
        icon    : "list_alt",
        to      : "/logs",
        active  : path => isPath(path, "/logs"),
    },
    {
        id      : "sanctions",
        label   : "navbar.sanctions.label",
        icon    : "gavel",
        to      : "/sanctions",
        active  : path => isPath(path, "/sanctions"),
    },
    {
        id      : "users",
        label   : "navbar.users.label",
        icon    : "groups",
        to      : "/users",
        active  : path => isPath(path, "/users"),
    },
    {
        id      : "tools",
        label   : "navbar.tools.label",
        icon    : "apps",
        to      : "/tools",
        active  : path => isPath(path, "/tools") || isPath(path, "/permissions-simulator") || isPath(path, "/graph"),
    },
    {
        id      : "settings",
        label   : "navbar.settings.label",
        icon    : "settings",
        to      : "/settings",
        active  : path => isPath(path, "/settings"),
    },
];

export default defineComponent({
    name: "AppDock",

    setup() {
        const route     = useRoute();
        const { i18n }  = useLocale();

        const items = computed(() => DockItems.map(item => ({
            ...item,
            current : item.active(route.path),
            title   : i18n(item.label),
        })));

        return () => (
            <nav class="app-dock" aria-label="Applications LogsCord">
                <div class="app-dock-rail">
                    {items.value.map(item => (
                        <router-link
                            key={item.id}
                            to={item.to}
                            class={{ "app-dock-item": true, "app-dock-item-active": item.current }}
                            aria-label={item.title}
                            title={item.title}
                        >
                            <i class="app-dock-icon material-symbols-outlined" aria-hidden="true">{item.icon}</i>
                            <span class="app-dock-tooltip">{item.title}</span>
                        </router-link>
                    ))}
                </div>
            </nav>
        );
    },
});
